import { seatClasses } from '../../../../../../../utils/constants';
import useTranslation from '../../../../../../hooks/translation/useTranslation';

function SearchRideClass({
  data,
  ride,
  chosenRide,
  setChosenRide,
  seatFormation,
  active = false,
}) {
  const { trans } = useTranslation();

  const getIsDisabled = () => {
    if (data.seats < 1) {
      return true;
    }

    if (seatFormation === 'book') {
      return false;
    }

    if (chosenRide?.id && `${chosenRide?.id}` !== `${ride.id}`) {
      return true;
    }

    if (chosenRide?.chosenClasses?.length === 1
    && !chosenRide?.chosenClasses?.includes(data.key) && [2, 'group-2'].includes(data.key)
    ) {
      const includesGroup2 = chosenRide?.chosenClasses?.find(
        (seat) => seat === 'group-2',
      );
      const includesSeat2 = chosenRide?.chosenClasses?.find(
        (seat) => seat === 2,
      );

      if (includesSeat2 && includesGroup2) return true;

      if (includesSeat2 || includesGroup2) return false;
    }

    return chosenRide?.chosenClasses?.length > 0 && !chosenRide?.chosenClasses?.includes(data.key);
  };

  const isDisabled = getIsDisabled();

  const handleSeatClassClick = () => {
    if (isDisabled) return;

    if (!chosenRide) {
      setChosenRide({
        ...ride,
        chosenClasses: [data.key],
      });
      return;
    }

    if (chosenRide?.id !== ride.id) {
      return;
    }

    const foundClass = chosenRide?.chosenClasses?.find((key) => key === data.key);

    if (!foundClass) {
      setChosenRide({
        ...ride,
        chosenClasses: [...chosenRide.chosenClasses, data.key],
      });
      return;
    }

    if (chosenRide?.chosenClasses.length === 1) {
      setChosenRide(null);
      return;
    }

    setChosenRide({
      ...ride,
      chosenClasses: chosenRide.chosenClasses.filter((key) => key !== data.key),
    });
  };

  const classIconSrc = seatClasses[data.key] || seatClasses[data.class];

  return (
    <div className="ride-class-wrapper">
      <button
        disabled={isDisabled}
        type="button"
        onClick={handleSeatClassClick}
        className={`ride-class ${active && 'active'}`}
      >
        <div className="flex gap-3 items-center">
          {classIconSrc && (
          <div className="flex items-center justify-center relative w-10">
            <img
              className="w-8 h-8 absolute"
              src={classIconSrc}
              alt="classIcon"
            />
          </div>
          )}
          <p className="m-0">
            {data.key === 'group-2' ? trans('wheelchair') : trans(data.class)}
          </p>
        </div>
        <h2 className="m-0 text-2xl leading-6">
          {data.price}
          {' '}
          {trans('gel')}
        </h2>
      </button>
      <p className="m-0">
        {trans('left')}
        {' '}
        <strong>
          {data.seats}
          {' '}
          {trans('seat')}
        </strong>
      </p>
    </div>
  );
}

export default SearchRideClass;
